// src/helpers/history.js

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();